// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconLanguagePath = 'M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm13.56 7.166A8.007 8.007 0 0 0 17.939 11h-2.96c-.11 2.396-.615 4.56-1.417 6.166ZM12.975 11c-.21 3.992-1.648 7-2.974 7-1.327 0-2.764-3.008-2.974-7h5.948Zm2.003-2h2.961a8.007 8.007 0 0 0-4.377-6.166c.802 1.606 1.306 3.77 1.416 6.166ZM6.44 2.834A8.007 8.007 0 0 0 2.062 9h2.96c.11-2.396.615-4.56 1.417-6.166ZM7.026 9C7.236 5.008 8.673 2 10 2c1.326 0 2.764 3.008 2.974 7H7.026Zm-2.003 2H2.062a8.007 8.007 0 0 0 4.377 6.166C5.637 15.56 5.133 13.396 5.023 11Z';
var IconLanguage = baseIcon('IconLanguage', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconLanguagePath
});
export default IconLanguage;
//# sourceMappingURL=index.js.map